import React, {Component} from 'react';
import Chart from 'chart.js';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  getJobPostsCreated as getJobPostsCreatedAction,
} from '../../../redux/middleware/admin/metrics';

import {
  getJobPostsCreated, getJobPostsCreatedError, getJobPostsCreatedPending
} from '../../../redux/reducers/admin/metrics';

class JobPostsCreatedChart extends Component {

  componentWillMount() {
    this.props.getJobPostsCreated();
  }

  componentDidUpdate() {
    if (this.shouldComponentRender()) this.renderChart();
  }

  shouldComponentRender = () => {
    const {jobs} = this.props;
    if (jobs === undefined) return false;
    return true;
  }

  renderChart() {
    var ctx = document.getElementById('jobPostsCreated');
    new Chart(ctx, {
        type: 'bar',
        data: {
            labels: this.props.jobs.map(job => job.month + '/' + job.year),
            datasets: [{
                label: 'Free job posted',
                data: this.props.jobs.map(job => job.count),
                backgroundColor: [
                    'rgba(242,89,36,0.6)',
                    'rgba(108,179,63,0.6)',
                    'rgba(0,112,120,0.6)',
                    'rgba(227,24,55,0.6)',
                    'rgba(82,97,172,0.6)',
                    'rgba(0,125,195,0.6)',
                    'rgba(55,242,123,0.6)',
                    'rgba(179,129,83,0.6)',
                    'rgba(120,62,81,0.98)',
                    'rgba(37,174,227,0.6)',
                    'rgba(172,66,65,0.6)',
                    'rgba(167,195,58,0.6)',
                    'rgba(168,242,110,0.6)',
                    'rgba(175,179,123,0.92)',
                    'rgba(67,88,120,0.78)',
                    'rgba(165,139,227,0.85)',
                    'rgba(77,172,118,0.79)',
                    'rgba(63,62,195,0.93)',
                ],
                borderColor: [
                    'rgba(242,89,36,1)',
                    'rgba(108,179,63,1)',
                    'rgba(0,112,120,1)',
                    'rgba(227,24,55,1)',
                    'rgba(82,97,172,1)',
                    'rgba(0,125,195,1)',
                    'rgba(55,242,123,1)',
                    'rgba(179,129,83,1)',
                    'rgba(120,62,81,0.98)',
                    'rgba(37,174,227,1)',
                    'rgba(172,66,65,1)',
                    'rgba(167,195,58,1)',
                    'rgba(168,242,110,1)',
                    'rgba(175,179,123,1)',
                    'rgba(67,88,120,1)',
                    'rgba(165,139,227,1)',
                    'rgba(77,172,118,1)',
                    'rgba(63,62,195,1)',
                ],
                borderWidth: 1
            }]
        },
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        }
    });
  }

  render() {
    if(!this.shouldComponentRender()) return <div>Loading...</div>
    return (
      <div>
        <h4>Free jobs posted</h4>
        <canvas id="jobPostsCreated" width="400" height="400"></canvas>
      </div>
    )
  }
}

const mapStateToProps = state => ({
    error: getJobPostsCreatedError(state),
    jobs: getJobPostsCreated(state),
    pending: getJobPostsCreatedPending(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({
    getJobPostsCreated: getJobPostsCreatedAction,
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(JobPostsCreatedChart)
